export default __webpack_public_path__ + "static/media/spay.4387022a.svg";